import { render, staticRenderFns } from "./FiltriStoricoAcquisti.vue?vue&type=template&id=79fdb422&"
import script from "./FiltriStoricoAcquisti.vue?vue&type=script&lang=js&"
export * from "./FiltriStoricoAcquisti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports